import { Pipe, PipeTransform } from '@angular/core';

import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';
import { TranslatePipe } from '@app/translate/TranslatePipe';
import { SearchType } from '@search-bar/entities/search-type';
import { FlightClass } from '@shared/base-search-bar/entities/flight-class';

@Pipe({
  name: 'passengerInput',
  pure: false,
  standalone: false
})

export class PassengerInputPipe implements PipeTransform {

  constructor(private translatePipe: TranslatePipe) { }

  transform(value: PassengerArrangement[], searchType: SearchType, classType?: FlightClass): string {
    if (value) {
      const quantity = value.reduce((total, currentValue) => total + currentValue.quantity, 0);
      const isBuses = this.isBus(searchType);
      const isSingular = quantity === 1;
      const seatsLabel = isSingular ? 'SEARCH_MODULE.PASSENGER_ARRANGEMENT.SEAT' : 'SEARCH_MODULE.PASSENGER_ARRANGEMENT.SEATS';
      const passengerLabel = isSingular ? 'PASSENGER' : 'PASSENGERS';
      const typeLabel = isBuses ? this.translatePipe.transform(seatsLabel) : this.translatePipe.transform(passengerLabel);
      const classLabel = classType ? `, ${this.translatePipe.transform(`SEARCH_MODULE.FLIGHT_CLASSES.${classType}`)}` : '';
      return isBuses ? `${quantity} ${typeLabel}` : `${quantity} ${typeLabel}${classLabel}`;
    } else return '';
  }

  private isBus(searchType: SearchType): boolean {
    return searchType === SearchType.BUSES_RESULTS || searchType === SearchType.HOME_BUSES;
  }
}
